export default {
  namespaced: true,
  state: {
    entries: {},
  },
  mutations: {
    setLookupEntry(state, { storageKey, entry }) {
      state.entries = { ...state.entries, [storageKey]: entry };
    },
    removeLookupEntry(state, storageKey) {
      if (!Object.prototype.hasOwnProperty.call(state.entries, storageKey)) return;
      const next = { ...state.entries };
      delete next[storageKey];
      state.entries = next;
    },
    clearLookupEntries(state) {
      if (Object.keys(state.entries).length === 0) return;
      state.entries = {};
    },
  },
};
